"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _excluded = ["classNames", "Component", "color", "size", "children", "stickyClassName", "stickyRemoveClassName", "defaultClassName"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref3) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.appBar || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? 'div' : _props$Component,
    _props$color = props.color,
    color = _props$color === void 0 ? 'paper1' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'appbar' : _props$size,
    children = props.children,
    _props$stickyClassNam = props.stickyClassName,
    stickyClassName = _props$stickyClassNam === void 0 ? classNames.sticky : _props$stickyClassNam,
    _props$stickyRemoveCl = props.stickyRemoveClassName,
    stickyRemoveClassName = _props$stickyRemoveCl === void 0 ? '' : _props$stickyRemoveCl,
    defaultClassName = props.defaultClassName,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== additionalStyles.appBar) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var container = (0, _react.useRef)();
  var reference = (0, _react.useRef)();
  var stickyClassList = stickyClassName && stickyClassName.split(' ');
  var stickyRemoveClassList = stickyRemoveClassName && stickyRemoveClassName.split(' ');
  function setSticky(e, sticky) {
    if (e) {
      if (typeof container.current.defaultClassName === 'undefined') {
        container.current.defaultClassName = e.className || '';
      }
      if (stickyClassList) {
        if (sticky) {
          var _e$classList;
          (_e$classList = e.classList).add.apply(_e$classList, (0, _toConsumableArray2["default"])(stickyClassList));
        }
      }
      if (stickyRemoveClassList) {
        if (sticky) {
          var _e$classList2;
          (_e$classList2 = e.classList).remove.apply(_e$classList2, (0, _toConsumableArray2["default"])(stickyRemoveClassList));
        }
      }
      if (!sticky) {
        e.className = container.current.defaultClassName;
      }
    }
  }
  function addIntersectionListeners() {
    if (reference.current && typeof IntersectionObserver !== 'undefined') {
      var resizeObserver = new IntersectionObserver(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
          e = _ref2[0];
        setSticky(container.current, e.intersectionRatio < 1);
      }, {
        threshold: [0]
      });
      resizeObserver.observe(reference.current);
      return function removeEventListener() {
        resizeObserver.disconnect();
      };
    }
  }
  (0, _react.useEffect)(function () {
    var removeIntersectionListeners = addIntersectionListeners();
    return function () {
      removeIntersectionListeners();
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: reference,
    className: classNames.reference
  }), /*#__PURE__*/_react["default"].createElement(_Paper["default"], Object.assign({
    ref: function ref(e) {
      container.current = e;
      if (_ref3) {
        if (typeof _ref3 === 'function') {
          _ref3(e);
        } else if (_ref3 && typeof _ref3 === 'object') {
          _ref3.current = e;
        }
      }
    },
    defaultClassName: (0, _clsx["default"])(classNames.appBar, defaultClassName),
    color: color,
    size: size,
    elevation: null
  }, rest), children));
});